import React from 'react'
import { useLocal } from '@/pages/dashboard/utils/customHook'

const Result = (props) => {
  const { activeItem = {} } = props
  const { getLocalText } = useLocal('component_tracking_day')

  return (
    <span>
      <span className="tracking-day">{getLocalText('label')}</span>{activeItem?.name?.includes('Days') ? activeItem?.name : activeItem?.name}
    </span>
  )
}

export default Result